import { graphql } from '../../types/swarmx/gql'

export const TokensQuery = graphql(`
  query Tokens($filter: Asset_filter, $limit: Int, $skip: Int) {
    assets(
      where: $filter
      first: $limit
      skip: $skip
      orderBy: tradedVolume
      orderDirection: desc
    ) {
      id
      name
      symbol
      address
      decimals
      tokenId
      assetType
      kya
      tokenStandard
      tradedVolume
    }
  }
`)
